module.exports = __webpack_public_path__ + "static/media/Element_15_treatments.a787e52a.svg";